import React from 'react';
import {DropdownButton, MenuItem, Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import TagManager from 'react-gtm-module';
import Can, {checkPermission} from '../common/guards/can';
import {USER_TYPE_ADMIN, USER_TYPE_REP, USER_TYPE_RETAILER, USER_TYPE_PRE_LOGIN} from '../../data/userTypes';
import './user-menu.css';
import UnreadMessages from './unread-messages';
import EditButton from './edit-button';
import PseudoLoginButton from './pseudo-login-button';
import { tradeSiteEnabled } from '../../utils/toggles';

const myProfile = (
  <MenuItem eventKey="1" href="/my-profile">
    My Profile
  </MenuItem>
);
const myMessages = (
  <MenuItem eventKey="2" href="/my-messages">
    My Messages
  </MenuItem>
);
const updatePassword = (
  <MenuItem eventKey="3" href="/update-password">
    Update Password
  </MenuItem>
);
const updateSecurityQuestion = (
  <MenuItem eventKey="4" href="/update-security-questions">
      Update Security Questions
  </MenuItem>
);
const pointsStatement = (
  <MenuItem eventKey="5" href="/points-statement">
    Points Statement
  </MenuItem>
);
const logout = (
  <MenuItem eventKey="6" href="/logout">
    Logout
  </MenuItem>
);

const adminMyProfile = (
  <MenuItem eventKey="11" href="/admin/my-profile">
    My Profile
  </MenuItem>
);
const adminUpdatePassword = (
  <MenuItem eventKey="12" href="/admin/update-password">
    Update Password
  </MenuItem>
);
const adminUpdateSecurityQuestion = (
  <MenuItem eventKey="13" href="/admin/update-security-questions">
    Update Security Questions
  </MenuItem>
);
const adminLogout = (
  <MenuItem eventKey="15" href="/admin/logout">
    Logout
  </MenuItem>
);

const repMyProfile = (
  <MenuItem eventKey="11" href="/team/my-profile">
    My Profile
  </MenuItem>
);
const repUpdatePassword = (
  <MenuItem eventKey="12" href="/team/update-password">
    Update Password
  </MenuItem>
);
const repUpdateSecurityQuestion = (
  <MenuItem eventKey="13" href="/team/update-security-questions">
    Update Security Questions
  </MenuItem>
);
const repLogout = (
  <MenuItem eventKey="15" href="/team/logout">
    Logout
  </MenuItem>
);
const repMyMessages = (
  <MenuItem eventKey="14" href="/team/my-messages">
    My Messages
  </MenuItem>
);
const preLoginButtons = (
  <div>
    <Button className="home-register-button" href="/registration/outlet">
      REGISTER
    </Button>
    <Button className="home-login-button" href="/login">
      <span className="glyphicon glyphicon-user"></span>
      LOGIN
    </Button>
  </div>
);

class UserMenu extends React.Component {
  showProfile = () => {
    const {type} = this.props;
    if (type === USER_TYPE_ADMIN) {
      return adminMyProfile;
    }
    if (type === USER_TYPE_REP) {
      return repMyProfile;
    }
    if (type === USER_TYPE_PRE_LOGIN) {
      return null;
    }
    return myProfile;
  };

  showMyMessages = () => {
    const {type} = this.props;
    if (type === USER_TYPE_RETAILER) {
      return checkPermission('view', 'web_app_messages') ? myMessages : null;
    }
    if (type === USER_TYPE_REP) {
      return checkPermission('view', 'messages_rep_area') ? repMyMessages : null;
    }
    return null;
  };

  showUpdatePassword = () => {
    const {type} = this.props;
    if (checkPermission('update', 'personal_info')) {
      if (type === USER_TYPE_ADMIN) {
        return adminUpdatePassword;
      }
      if (type === USER_TYPE_REP) {
        return repUpdatePassword;
      }
      return updatePassword;
    }

    return null;
  };

  showUpdateSecurityQuestions = () => {
    const {type} = this.props;
    if (checkPermission('update', 'personal_info')) {
      if (type === USER_TYPE_ADMIN) {
        return adminUpdateSecurityQuestion;
      }
      if (type === USER_TYPE_REP) {
        return repUpdateSecurityQuestion;
      }
      return updateSecurityQuestion;
    }

    return null;
  };

  showPointsStatement = () => {
    const {user, type} = this.props;
    if (!checkPermission('view', 'web_app_points')) {
      return null;
    }
    return (user.attributes['has-reward-outlet'] && type === USER_TYPE_RETAILER) && pointsStatement;
  };

  showLogout = () => {
    const {type} = this.props;
    if (type === USER_TYPE_ADMIN) {
      return adminLogout;
    }
    if (type === USER_TYPE_REP) {
      return repLogout;
    }
    if (type === USER_TYPE_PRE_LOGIN) {
      return null;
    }
    return logout;
  };

  showEditPageButton = () => {
    const {type} = this.props;
    return type !== USER_TYPE_ADMIN || window.location.href.match('/admin/news/edit-content') !== null;
  }

  tradeSiteLinks = () => preLoginButtons;


  editContent = () => {
    this.props.dispatch({type: 'TOGGLE_EDIT_CONTENT'});
  };

  myMessagesUrl = () => {
    const {type} = this.props;
    if (type === USER_TYPE_RETAILER) {
      return '/my-messages';
    }
    if (type === USER_TYPE_REP) {
      return '/team/my-messages';
    }
    return null;
  };

  componentDidMount() {
    const {user} = this.props;
    const mode = user.attributes['pseudo-login'] ? 'demo_mode' : 'standard_mode';
    TagManager.dataLayer({
      dataLayer: {
        viewMode: mode
      }
    });
  }

  render() {
    const {
      type, user, unreadMessages
    } = this.props;

    const messageIconPermissions = {
      [USER_TYPE_RETAILER]: 'web_app_messages',
      [USER_TYPE_REP]: 'messages_rep_area,'
    };

    return (
      <div id="user-panel-wrap">
        <div className="user-panel">
          {user.attributes['pseudo-login'] && <PseudoLoginButton/>}
          { tradeSiteEnabled() && type === 'pre_login' ? this.tradeSiteLinks() : null}
          { type !== 'pre_login' ? (
            <div>
              <Can action="view" subjectClass={messageIconPermissions[type] || messageIconPermissions[USER_TYPE_REP]}>
                <UnreadMessages
                  unreadMessages={unreadMessages}
                  show={type !== USER_TYPE_ADMIN}
                  url={this.myMessagesUrl()}
                />
              </Can>
              <DropdownButton
                bsStyle="primary"
                id="userdopdown"
                title={`${user.attributes['first-name']} ${user.attributes['last-name']}`}
              >
                {this.showProfile()}
                {this.showMyMessages()}
                {this.showUpdatePassword()}
                {this.showUpdateSecurityQuestions()}
                <MenuItem divider/>
                {this.showPointsStatement()}
                {this.showLogout()}
              </DropdownButton>

              <EditButton
                show={this.showEditPageButton()}
                onClick={this.editContent}
              />
            </div>
          ) : null}
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  user: state.viewConfig.profile,
  unreadMessages: state.messages.unreadMessagesCount
});

export default connect(mapStateToProps)(UserMenu);



// WEBPACK FOOTER //
// ./src/components/user-menu/index.jsx